import { render, staticRenderFns } from "./Tribute.vue?vue&type=template&id=32095b88"
import script from "./Tribute.vue?vue&type=script&lang=js"
export * from "./Tribute.vue?vue&type=script&lang=js"
import style0 from "./Tribute.vue?vue&type=style&index=0&id=32095b88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports